export default __webpack_public_path__ + "static/nome-c3a45b3fc2b5efabc9932512aa4f20ba.jpg";